<footer class="main-footer cus-bor"  style="margin-left: 10px !important;">
    <div class="float-right d-none d-sm-block"><b>Version</b> 4.0.1.15</div>
    <strong
      >Copyright &copy; 2009-2022
      <a href="http://thienan.vn">Thiên An</a>.</strong
    >
   Portal
  </footer>
  
